module.exports = __webpack_public_path__ + "img/Head_fourth.3062fd79.png";